// @flow

import React from 'react';
import {AlignBox} from 'sail/Align';
import Box from 'sail/Box';
import Interactive from 'sail/Interactive';
import Spinner from 'sail/Spinner';
import {BodyAlt, BodyAltTextProps} from 'sail/Text';
import {UnstyledLink} from 'sail/UnstyledLink';
import {DocsIcon} from 'docs/components';
import {useSidebar} from 'docs/data';
import FlagIcon, {FLAG_COUNTRY_CODES} from 'sail/FlagIcon';

import type {LinkBehaviorProps} from 'sail/UnstyledLink/types';

const getColor = (mouse) =>
  mouse === 'hover' || mouse === 'active' ? 'default' : 'gray';

type SelectorLinkProps = LinkBehaviorProps & {
  icon: string,
  pending: boolean,
  label: string,
  ariaLabel: string,
  showLabel: boolean,
};

type GetIconProps = {
  pending: boolean,
  icon: string,
  mouse: string,
};

const getIcon = ({pending, icon, mouse}: GetIconProps) => {
  if (pending) {
    return <Spinner size="small" />;
  }
  if (FLAG_COUNTRY_CODES[icon]) {
    return <FlagIcon countryCode={FLAG_COUNTRY_CODES[icon]} />;
  }
  return <DocsIcon icon={icon} size={16} color={getColor(mouse)} />;
};

export const SelectorLink = ({
  icon,
  pending,
  label,
  ariaLabel,
  showLabel,
  ...linkProps
}: SelectorLinkProps) => {
  const {open} = useSidebar();
  return (
    <Interactive>
      {({mouse, focus}) => (
        <UnstyledLink {...linkProps} aria-label={ariaLabel}>
          <AlignBox reference={BodyAltTextProps}>
            {getIcon({pending, icon, mouse})}
            {showLabel && open && (
              <Box margin={{left: 2}} padding={{left: 8}}>
                <BodyAlt color={getColor(mouse)}>
                  <span style={{whiteSpace: 'nowrap'}}>{label}</span>
                </BodyAlt>
              </Box>
            )}
          </AlignBox>
        </UnstyledLink>
      )}
    </Interactive>
  );
};
